const GAMES_LIST =
    [
        {
            "Id": 20,
            "Title": "Powerball",
            "Balls": {
                "Normal": { "Count": 5 },
                "Bonus": { "Count": 1, "Title": "PB" },
                "Multiplier": { "Count": 0, "Title": "PP" }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/Powerball",
            "CheckNumbersPageUrl": "/Data/Draw-Games/Powerball/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=powerball"
        },
        {
            "Id": 15,
            "Title": "Mega Millions",
            "Balls": {
                "Normal": { "Count": 5 },
                "Bonus": { "Count": 1, "Title": "MB" },
                "Multiplier": { "Count": 0, "Title": "MP" }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/MegaMillions",
            "CheckNumbersPageUrl": "/Data/Draw-Games/MegaMillions/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=megamillions"
        },
        {
            "Id": 1070,
            "Title": "Bank a Million",
            "Balls": {
                "Normal": { "Count": 6 },
                "Bonus": { "Count": 1, "Title": "Bonus Ball" },
                "Multiplier": { "Count": 0, }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/BankaMillion",
            "CheckNumbersPageUrl": "/Data/Draw-Games/BankAMillion/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=bankamillion"
        },
        {
            "Id": 1050,
            "Title": "Pick 3",
            "Balls": {
                "Normal": { "Count": 3 },
                "Bonus": { "Count": 0 },
                "Multiplier": { "Count": 0 }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/Pick3",
            "CheckNumbersPageUrl": "/Data/Draw-Games/Pick3/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=pick3"
        },
        {
            "Id": 1040,
            "Title": "Pick 4",
            "Balls": {
                "Normal": { "Count": 4 },
                "Bonus": { "Count": 0 },
                "Multiplier": { "Count": 0 }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/Pick4",
            "CheckNumbersPageUrl": "/Data/Draw-Games/Pick4/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=pick4"
        },
        {
            "Id": 1030,
            "Title": "Cash 5",
            "Balls": {
                "Normal": { "Count": 5 },
                "Bonus": { "Count": 0 },
                "Multiplier": { "Count": 0 }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/Cash5",
            "CheckNumbersPageUrl": "/Data/Draw-Games/Cash5/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=cash5"
        },
        {
            "Id": 1065,
            "Title": "Cash 4 Life",
            "Balls": {
                "Normal": { "Count": 5 },
                "Bonus": { "Count": 1, "Title": "Cash Ball" },
                "Multiplier": { "Count": 0 }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/Cash4Life",
            "CheckNumbersPageUrl": "/Data/Draw-Games/Cash4Life/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=cash4life"
        },
        {
            "Id": 30,
            "Title": "Keno",
            "Balls": {
                "Normal": { "Count": 1 },
                "Bonus": { "Count": 0 },
                "Multiplier": { "Count": 0 }
            },
            "DrawGamePageUrl": "/Data/Draw-Games/Keno",
            "CheckNumbersPageUrl": "/Data/Draw-Games/Keno/CheckMyNumbers",
            "CheckMyNumbersTab": "/CheckMyNumbers?scrollto=keno"
        }
    ];

export default GAMES_LIST;


// WEBPACK FOOTER //
// ./shared/scripts/GAMES_LIST.js